import { paths } from "@utils/navigation";
import { FORM_FIELDS } from "./constants";

const {
  vesselCall: { preArrivalNotification, imoFAL, additionalDocuments, create },
} = paths;

const FAL_STEPS_COUNT = 7;
const FAL_KEY = "fal-form";

export type FalStep = { label: string; path: string };

export const getFalSteps = (): FalStep[] =>
  Array.from({ length: FAL_STEPS_COUNT }, (_, i) => i + 1).map((idx) => ({
    label: `vessel-call.create.imo-fal.${FAL_KEY}-${idx}`,
    path: `${FAL_KEY}-${idx}`,
  }));

export type CreateStep = {
  label: string;
  path: string;
  substeps?: FalStep[];
};

export const steps: CreateStep[] = [
  {
    path: `${create}/${preArrivalNotification}`,
    label: "vessel-call.create.preArrivalNotification",
  },
  {
    path: `${create}/${imoFAL}`,
    label: "vessel-call.create.imoFAL",
    substeps: getFalSteps(),
  },
  { path: `${create}/${additionalDocuments}`, label: "vessel-call.create.additionalDocuments" },
];

export const generateCallAdditionalDocumentField = {
  root: (idx: number) => `${FORM_FIELDS.CALL_ADDITIONAL_DOCUMENTS}.${idx}` as const,
  url: (idx: number) =>
    `${FORM_FIELDS.CALL_ADDITIONAL_DOCUMENTS}.${idx}.${FORM_FIELDS.DOCUMENT_URL}` as const,
  documentType: (idx: number) =>
    `${FORM_FIELDS.CALL_ADDITIONAL_DOCUMENTS}.${idx}.${FORM_FIELDS.DOCUMENT_TYPE}` as const,
  otherSpecifyType: (idx: number) =>
    `${FORM_FIELDS.CALL_ADDITIONAL_DOCUMENTS}.${idx}.${FORM_FIELDS.OTHER_SPECIFY_TYPE}` as const,
  documentName: (idx: number) =>
    `${FORM_FIELDS.CALL_ADDITIONAL_DOCUMENTS}.${idx}.${FORM_FIELDS.DOCUMENT_NAME}` as const,
  documentSummary: (idx: number) =>
    `${FORM_FIELDS.CALL_ADDITIONAL_DOCUMENTS}.${idx}.${FORM_FIELDS.DOCUMENT_SUMMARY}` as const,
  fileName: (idx: number) =>
    `${FORM_FIELDS.CALL_ADDITIONAL_DOCUMENTS}.${idx}.${FORM_FIELDS.FILE_NAME}` as const,
  issueDate: (idx: number) =>
    `${FORM_FIELDS.CALL_ADDITIONAL_DOCUMENTS}.${idx}.${FORM_FIELDS.ISSUE_DATE}` as const,
  expiryDate: (idx: number) =>
    `${FORM_FIELDS.CALL_ADDITIONAL_DOCUMENTS}.${idx}.${FORM_FIELDS.EXPIRY_DATE}` as const,
};
